export default "__VITE_ASSET__BhjE9rM9__"